<template>
  <div class="footer-wrapper d-flex p-fixed justify-center items-center">
    <slot name="footer" />
  </div>
</template>

<style scoped>
.footer-wrapper {
  bottom: 0;
  left: 0;
  right: 0;
  height: 10vh;
  height: 10dvh;
  width: 100%;
  max-width: 84rem;
  margin: auto;
  background: #fff;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  vertical-align: middle;
  z-index: 2;
}
</style>
